<template>
  <div class="inner">

    <nav class="breadcrumb is-small has-dot-separator">
      <ul>
        <li>
          <b-icon icon="home" size="is-small" />
        </li>
        <li v-if="portefeuille" class="is-active"><a href="#">
            {{ portefeuille.name }}
          </a></li>
        <li v-if="site" class="is-active"><a href="#">
            {{ site.name }}
          </a></li>
        <li v-if="bien" class="is-active"><a href="#">
            {{ bien.name }}
          </a></li>
        <li class="is-active"><a href="#">
            {{ activeTab === 0 ? $t('p-bien.title-doc') : $t('p-bien.title-question') }}
          </a></li>
      </ul>
    </nav>

    <PortefeuilleDocumentApercu v-if="activeTab === 0 && ($route.query.invdoc || $route.query.dl)" />

    <b-tabs v-model="activeTab" :animated="false">
      <b-tab-item>
        <template slot="header">
          <b-icon icon="folder" size="is-small" />
          {{$t('p-bien.title-doc')}}
        </template>

        <PortefeuilleDocuments />

      </b-tab-item>
      <!-- Règle métier : questions et notifications visibles seulement quand les
           CGA du portefeuille sont acceptées, ou quand il n'y a pas de CGA
           obligatoires (getter cgaOk). -->
      <b-tab-item :visible="allowQuestions && cgaOk">
        <template slot="header">
          <b-icon icon="question-circle" size="is-small" />
          {{$t('p-bien.title-question')}}
        </template>

        <PortefeuilleQuestions />

      </b-tab-item>
      <b-tab-item :visible="cgaOk">
        <template slot="header">
          <b-icon icon="envelope" size="is-small" pack="far" />
          {{$t('p-bien.title-notif')}}
        </template>

        <PortefeuilleNotifications />

      </b-tab-item>
    </b-tabs>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import PortefeuilleDocumentApercu from '@/components/Portefeuille/DocumentApercu'
import PortefeuilleDocuments from '@/components/Portefeuille/Documents'
import PortefeuilleNotifications from '@/components/Portefeuille/Notifications'
import PortefeuilleQuestions from '@/components/Portefeuille/Questions'

export default {
  components: {
    PortefeuilleDocumentApercu,
    PortefeuilleDocuments,
    PortefeuilleNotifications,
    PortefeuilleQuestions,
  },
  data () {
    let activeTab = 0
    if (this.$route.params.tab === 'questions') activeTab = 1
    else if (this.$route.params.tab === 'notifications') activeTab = 2
    return {
      activeTab,
    }
  },
  computed: {
    ...mapState({
      biens: state => state.inv.biens,
    }),
    ...mapGetters({
      allowQuestions: 'inv/allowQuestions',
    }),
    portefeuille () {
      if (!this.$route.params.portefeuille) return
      const value = this.biens.find(i => i.portefeuille === +this.$route.params.portefeuille)
      return value ? {
        id: value.portefeuille,
        name: value.portefeuilleName,
      } : null
    },
    site () {
      if (!this.$route.params.site) return
      const value = this.biens.find(i => i.site === +this.$route.params.site)
      return value ? {
        id: value.site,
        name: value.siteName,
      } : null
    },
    bien () {
      if (!this.$route.params.bien || !this.site) return
      return _.find(this.biens, {
        id: +this.$route.params.bien,
        portefeuille: +this.$route.params.portefeuille,
      }) || null
    },
    // CGA acceptées, ou pas de CGA obligatoires — conditionne les onglets
    // Questions et Notifications (même règle que sur l'accueil du portefeuille).
    cgaOk () {
      return this.$store.getters.cgaOk(this.$route.params.portefeuille)
    },
  },
  watch: {
    '$route.params.portefeuille': 'fetchCgaStatus',
    activeTab () {
      if (this.activeTab === 1) {
        this.$router.replace(`/portefeuille/${this.$route.params.portefeuille}/${this.$route.params.site}/${this.$route.params.bien}/questions`)
      } else if (this.activeTab === 2) {
        this.$router.replace(`/portefeuille/${this.$route.params.portefeuille}/${this.$route.params.site}/${this.$route.params.bien}/notifications`)
      } else {
        this.$router.replace(`/portefeuille/${this.$route.params.portefeuille}/${this.$route.params.site}/${this.$route.params.bien}`)
      }
    },
    portefeuille () {
      this.$store.commit('inv/PORTEFEUILLE_SETTINGS', this.$route.params.portefeuille)
    },
    bien () {
      this.$store.commit('inv/BIEN_CURRENT', this.$route.params.bien)
    },
  },
  created () {
    this.$store.commit('inv/BIEN_CURRENT', this.$route.params.bien)
    this.$store.commit('inv/PORTEFEUILLE_SETTINGS', this.$route.params.portefeuille)
    this.fetchCgaStatus()
  },
  methods: {
    // Charge l'état CGA du portefeuille dans le store (getter cgaOk) : cette page
    // n'avait aucun chargement CGA, la visibilité des onglets en dépend désormais.
    async fetchCgaStatus () {
      if (!this.$route.params.portefeuille) return
      try {
        await this.$store.dispatch('getCgaValue', { id: this.$route.params.portefeuille })
      } catch (error) {
        // Échec = état inconnu : les onglets conditionnés restent masqués, la
        // consultation documentaire n'est pas affectée.
        console.error('Erreur lors de la récupération de la valeur CGA:', error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.inner {
  padding: 1em 1em;
}

.b-tabs {
  background: #fff;
}
</style>
